/* Galerie-Videokacheln (sections/alb-galerie): Autoplay erst in Viewport-Nähe.
   Das autoplay-Attribut im HTML zwingt Chrome, die komplette Datei sofort zu laden (auf der PDP
   11,6 MB Full-HD). Hier: <video preload="none" data-alb-lazy-video="autoplay"> – erst wenn die
   Kachel ~200 px vor dem Viewport steht, wird geladen und stumm gestartet; außerhalb pausiert.
   Modus "controls": nichts zu tun (Nutzer klickt Play, preload="none" bleibt).
   Ohne IntersectionObserver (sehr alte Browser): sofort starten wie bisher. */
(() => {
  'use strict';
  if (window.albLazyVideoInit) return;
  window.albLazyVideoInit = true;

  const starten = (v) => {
    if (v.dataset.albStarted !== '1') {
      v.dataset.albStarted = '1';
      v.muted = true;
      v.setAttribute('preload', 'auto');
      v.load();
    }
    const p = v.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  const init = () => {
    const videos = document.querySelectorAll('video[data-alb-lazy-video="autoplay"]:not([data-alb-lazy-bound])');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach((v) => { v.setAttribute('data-alb-lazy-bound', '1'); starten(v); });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) {
          starten(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach((v) => { v.setAttribute('data-alb-lazy-bound', '1'); io.observe(v); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Theme-Editor: neu gerenderte Sections nachbinden */
  document.addEventListener('shopify:section:load', init);
})();
